import each from 'lodash/each';

import logger from '../../utils/logger';

class Pinterest {
  _init(state, commit, id) {
    if (state.currentIds.lastPinterest !== id) {
      pintrk('load', id);
      commit('trackId', { property: 'lastPinterest', value: id });
      logger.log(`${id} initialize.`);
    } else {
      logger.log(`${id} already initialized.`);
    }
  }

  _trackEvent(state, commit, id, pinEvent, type, message, payload) {
    this._init(state, commit, id);

    if (payload) {
      pintrk('track', pinEvent, payload);
    } else {
      pintrk('track', pinEvent);
    }

    if (payload) {
      logger.log(`${type} ${id} ${message} event with payload:`);
      logger.log(payload);
    } else {
      logger.log(`${type} ${id} ${message} event`);
    }
  }

  clientViewSales({ state, commit }) {
    logger.groupCollapsed('Client Pinterest');

    var idGlobal = state.campaign.tracking.global.pinterest,
      idCampaign = state.campaign.tracking.campaign.pinterest;

    if (logger.checkCampaign(idCampaign)) {
      this._trackEvent(state, commit, idCampaign, 'PageVisit', 'Campaign specific', 'page visit');
    }

    if (logger.checkGlobal(idGlobal, idCampaign)) {
      this._trackEvent(state, commit, idGlobal, 'PageVisit', 'Global', 'page visit');
    }

    logger.groupEnd();
  }

  clientViewThankYou({ state, commit }) {
    logger.groupCollapsed('Client Pinterest');

    each(state.order.orders, order => {
      logger.groupCollapsed(order.campaign_name);

      var idGlobal = state.order.tracking[order.analytics_cid].global.pinterest,
        idCampaign = state.order.tracking[order.analytics_cid].campaign.pinterest,
        purchase = {
          value: Math.round((order.sale_total + order.shipping_discount - order.shipping_total) * 100) / 100,
          order_quantity: 0,
          currency: 'USD',
          line_items: [],
        };

      each(order.products, product => {
        purchase.line_items.push({
          product_name: order.campaign_name,
          product_id: product.product_id,
          product_price: Math.round(product.discounted_price / product.quantity * 100) / 100,
          product_quantity: product.quantity,
          product_variant: product.color,
          product_category: order.campaign_category,
          product_size: product.size,
          product_brand: product.type,
        });
        purchase.order_quantity += product.quantity;
      })

      if (logger.checkCampaign(idCampaign)) {
        this._trackEvent(state, commit, idCampaign, 'Checkout', 'Campaign specific', 'checkout', purchase);
      }

      if (logger.checkGlobal(idGlobal, idCampaign)) {
        this._trackEvent(state, commit, idGlobal, 'Checkout', 'Global', 'checkout', purchase);
      }

      logger.groupEnd();
    });

    logger.groupEnd();
  }

  clientAddToCart({ state, commit }) {
    logger.groupCollapsed('Client Pinterest');

    let idGlobal = state.campaign.tracking.global.pinterest,
      idCampaign = state.campaign.tracking.campaign.pinterest;

    if (logger.checkCampaign(idCampaign)) {
      this._trackEvent(state, commit, idCampaign, 'AddToCart', 'Campaign specific', 'add to cart');
    }

    if (logger.checkGlobal(idGlobal, idCampaign)) {
      this._trackEvent(state, commit, idGlobal, 'AddToCart', 'Global', 'add to cart');
    }

    logger.groupEnd();
  }
};

export default new Pinterest();